import { type ReactNode } from 'react'

import { type ColorIdType } from '@/defs/mtg'
import { cn } from '@/utils/commonUtil'

import styles from './ColorIdBorder.module.scss'

type Props = {
  children?: ReactNode
  colorId: ColorIdType
  vertical?: boolean
}

export const ColorIdBorder = ({ children, colorId, vertical }: Props) => (
  <div className={cn(styles.container, { colorId, styles, vertical })}>{children}</div>
)
